var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"6"}},[_c('YearSelectComponent',{attrs:{"start":_vm.year},on:{"update:year":_vm.handleYearUpdate}})],1)],1),_c('StatisticsTable',{attrs:{"statistics":_vm.statistics}}),_c('ExportStatisticsToExcel',{attrs:{"data":_vm.statistics,"year":_vm.year}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }